import { render, staticRenderFns } from "./LifeAnnuity.vue?vue&type=template&id=ec72860a&scoped=true&"
import script from "./LifeAnnuity.vue?vue&type=script&lang=js&"
export * from "./LifeAnnuity.vue?vue&type=script&lang=js&"
import style0 from "./LifeAnnuity.vue?vue&type=style&index=0&id=ec72860a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec72860a",
  null
  
)

export default component.exports